export default "__VITE_ASSET__90n52oyv__ 1600w, __VITE_ASSET__qkGByo36__ 800w";